import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAutomationStepEntity } from './outreach-automation-step.entity';

@Index('idx_creator_user', ['creatorUserId'], {})
@Index('idx_deleted_user', ['deletedUserId'], {})
@Index('idx_from_step', ['fkFromStepId'], {})
@Index('idx_modified_user', ['modifiedUserId'], {})
@Index('idx_owner_user', ['ownerUserId'], {})
@Index('idx_to_step', ['fkToStepId'], {})
@Index('unique_connection', ['fkFromStepId', 'fkToStepId', 'connectionType'], {
	unique: true,
})
@Entity('_outreach_automation_step_connection')
export class OutreachAutomationStepConnectionEntity extends BaseEntity {
	@Column('int', { name: '_fk__from_step__id', unsigned: true })
	public fkFromStepId!: number;

	@Column('int', { name: '_fk__to_step__id', unsigned: true })
	public fkToStepId!: number;

	@Column('enum', {
		name: '_connection_type',
		enum: ['next', 'true', 'false', 'split_a', 'split_b'],
		default: () => "'next'",
	})
	public connectionType!: 'next' | 'true' | 'false' | 'split_a' | 'split_b';

	@ManyToOne(
		() => OutreachAutomationStepEntity,
		(outreachAutomationStep) =>
			outreachAutomationStep.outreachAutomationStepConnections,
		{ onDelete: 'CASCADE', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: '_fk__from_step__id', referencedColumnName: 'id' }])
	public fkFromStep!: OutreachAutomationStepEntity;

	@ManyToOne(
		() => OutreachAutomationStepEntity,
		(outreachAutomationStep) =>
			outreachAutomationStep.outreachAutomationStepConnections2,
		{ onDelete: 'CASCADE', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: '_fk__to_step__id', referencedColumnName: 'id' }])
	public fkToStep!: OutreachAutomationStepEntity;
}
